import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Home from "./pages/Home/Home";
import Auth from "./pages/Auth/Auth";
import Quote from "./pages/Quote/Quote";
import Payment from "./pages/Payment/Payment";
import Admin from "./pages/Admin/Admin";
import Translator from "./pages/Translator/Translator";
import Client from "./pages/Client/Client";
import Settings from "./pages/Settings/Settings";
import NotFound from "./pages/NotFound/NotFound";
import Confirmation from "./pages/Confirmation/Confirmation";
import Reset from "./pages/Reset/Reset";
import ContactUs from "./pages/ContactUs/ContactUs";
import Join from "./pages/Join/Join";
import Company from "./pages/Company/Company";
import Services from "./pages/Services/Services";
import Translation from "./pages/Translation/Translation";
import Service from "./pages/Service/Service";
import Industry from "./pages/Industry/Industry";
import Interpretation from "./pages/Interpretation/Interpretation";
import Pricing from "./pages/Pricing/Pricing";
import Language from "./pages/Language/Language";
import Languages from "./pages/Languages/Languages";
import LanguageTemplate from "./pages/LanguageTemplate/LanguageTemplate";
import OnlineTranslation from "./pages/OnlineTranslation/Translation";
import SwornTemplate from "./pages/SwornTemplate/SwornTemplate";
import BusinessTemplate from "./pages/BusinessTemplate/BusinessTemplate";
import CertifiedTemplate from "./pages/CertifiedTemplate/CertifiedTemplate";
import NotarizedTemplate from "./pages/NotarizedTemplate/NotarizedTemplate";
import SimultaneousTemplate from "./pages/SimultaneousTemplate/SimultaneousTemplate";
import InterpretationTemplate from "./pages/InterpretationTemplate/InterpretationTemplate";
import TranslationTemplate from "./pages/TranslationTemplate/TranslationTemplate";
import Compare from "./pages/Compare/Compare";
import Article from "./pages/Article/Article";
import Terms from "./pages/Terms/Terms";
import Alert from "./components/Alert/Alert";
import Blog from "./pages/Blog/Blog";
import Chat from "./components/Chat/Chat";

import "./App.css";

const App = () => {
  return (
    <Router>
      <div className="App">
        <Alert />
        <Switch>
          <Route path="/resetPassword/:token" component={Reset} exact />
          <Route path="/confirmation/:token" component={Confirmation} exact />
          <Route path="/terms-and-condition" component={Terms} exact />
          <Route path="/blog" component={Blog} exact />
          <Route path="/blog/:article" component={Article} exact />
          <Route
            path="/certified-document-translation/:location"
            component={CertifiedTemplate}
            exact
          />
          <Route
            path="/business-document-translation/:location"
            component={BusinessTemplate}
            exact
          />
          <Route
            path="/sworn-document-translation/:location"
            component={SwornTemplate}
            exact
          />
          <Route
            path="/notarized-translation/:location"
            component={NotarizedTemplate}
            exact
          />
          <Route path="/compare/:company" component={Compare} exact />
          <Route
            path="/online-translation"
            component={OnlineTranslation}
            exact
          />
          <Route path="/pricing" component={Pricing} exact />
          <Route path="/on/:type" component={Services} exact />
          <Route path="/translation/:type" component={Languages} exact />
          <Route
            path="/interpretation/:type"
            component={LanguageTemplate}
            exact
          />
          <Route
            path="/simultaneous/:type/:location"
            component={SimultaneousTemplate}
            exact
          />
          <Route
            path="/interpretaion/:type/:location"
            component={InterpretationTemplate}
            exact
          />
          <Route
            path="/translation/:type/:location"
            component={TranslationTemplate}
            exact
          />
          <Route path="/services" component={Service} exact />
          <Route path="/company" component={Company} exact />
          <Route path="/languages" component={Language} exact />
          <Route path="/translation" component={Translation} exact />
          <Route path="/interpretation" component={Interpretation} exact />
          <Route path="/industries" component={Industry} exact />
          <Route path="/contact-us" component={ContactUs} exact />
          <Route path="/join-us" component={Join} exact />
          <Route path="/settings" component={Settings} exact />
          <Route path="/projects/:section" component={Client} exact />
          <Route path="/translator/:section" component={Translator} exact />
          <Route path="/admin/:section" component={Admin} exact />
          <Route path="/payment/:id" component={Payment} exact />
          <Route path="/quote" component={Quote} exact />
          <Route path="/auth/:path" component={Auth} exact />
          <Route path="/" component={Home} exact />
          <Route path="" component={NotFound} />
        </Switch>
        <Chat />
      </div>
    </Router>
  );
};

export default App;
